import auth0 from 'auth0-js'

import { storage } from '@/utils/storage'

export class Auth {
  constructor () {
    this.signUpMail = this.signUpMail.bind(this)
    this.loginMail = this.loginMail.bind(this)
    this.handleAuth = this.handleAuth.bind(this)
    this.loginMS = this.loginMS.bind(this)
    this.logout = this.logout.bind(this)
    this.resetPassword = this.resetPassword.bind(this)

    this.auth0 = new auth0.WebAuth({
      domain: process.env.VUE_APP_AUTH_DOMAIN,
      clientID: process.env.VUE_APP_AUTH_CLIENTID,
      audience: process.env.VUE_APP_AUTH_AUDIENCE,
      redirectUri: process.env.VUE_APP_AUTH_REDIRECTURI,
      responseType: 'token id_token',
      scope: 'openid profile email',
      auto_login: false,
      returnTo: process.env.VUE_APP_AUTH_RETURNTO
    })
  }

  loginMS () {
    this.auth0.authorize({connection: 'TestAzure'})
  }

  crossOrigin () {
    this.auth0.crossOriginVerification().then(res => {
      console.log('res', res)
    }).catch(err => {
      console.log('err', err)
    })
  }

  resetPassword (mail) {
    return new Promise((resolve, reject) => {
      this.auth0.changePassword({
        connection: 'sopra-db-connection',
        email: mail,
        redirect_url: process.env.VUE_APP_AUTH_REDIRECTURI
      }, (err, res) => {
        if (err) {
          reject(err.message)
        } else {
          resolve(res)
        }
      })
    })
  }

  signUpMail (mail, password) {
    return new Promise((resolve, reject) => {
      this.auth0.signup({
        email: mail,
        password: password,
        connection: 'sopra-db-connection'
      }, response => {
        
          if (response && response.statusCode === 400) {
            let res = ''

            if (response.description) {
              res = response.description
            }
            if (res === '') {
              res = 'You are not allowed to register.'
            }

            reject(res)
          }

          resolve()
        }
      )
    })
  }

  loginMail (mail, password) {
    return new Promise((resolve, reject) => {
      this.auth0.login({
        email: mail,
        password: password,
        realm: 'sopra-db-connection'
      }, response => {
          if (response && (response.statusCode === 400 || response.error)) {
            reject(response.description)
          }

          resolve()
        }
      )
    })
  }

  handleAuth () {
    let token = null

    return new Promise(async (resolve, reject) => {
      token = await this.getTokenUrl()
      if (token === null) {
        token = await storage.getItem('AUTH')
      }

      if (token !== null) {
        storage.setItem('AUTH', token)
        resolve(token)
      }
      else {
        reject()
      }
    })
  }

  getTokenUrl () {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash({ hash: window.location.hash }, (err, authResult) => {
        if (err) {
          resolve(null)
          console.log(err)
        }

        if (authResult && authResult.accessToken) {
          resolve(authResult.accessToken)
        }

        resolve(null)
      })
    })
  }

  logout () {
    storage.removeItem('AUTH')
    storage.removeItem('me')
    this.auth0.logout({
      returnTo: process.env.VUE_APP_AUTH_RETURNTO_LOGOUT
    })
  }
}

export const auth = new Auth()